import React from 'react';

export const Hero = ({ onContactClick, t }) => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white pt-20">
      {/* Strategic control system diagram */}
      <div className="absolute inset-0 opacity-[0.08]">
        {/* Central axis */}
        <div className="absolute left-1/2 top-0 bottom-0 w-px bg-gray-900 transform -translate-x-1/2" />
        <div className="absolute top-1/2 left-0 right-0 h-px bg-gray-900 transform -translate-y-1/2" />
        
        {/* Network nodes */}
        <div className="absolute top-1/3 left-1/4 w-3 h-3 border-2 border-gray-900 rounded-full" />
        <div className="absolute top-1/3 left-3/4 w-3 h-3 border-2 border-gray-900 rounded-full" />
        <div className="absolute top-2/3 left-1/3 w-3 h-3 border-2 border-gray-900 rounded-full" />
        <div className="absolute top-2/3 left-2/3 w-3 h-3 border-2 border-gray-900 rounded-full" />
        
        {/* Connection lines */}
        <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <line x1="25%" y1="33%" x2="50%" y2="50%" stroke="#000" strokeWidth="1" />
          <line x1="75%" y1="33%" x2="50%" y2="50%" stroke="#000" strokeWidth="1" />
          <line x1="33%" y1="66%" x2="50%" y2="50%" stroke="#000" strokeWidth="1" />
          <line x1="66%" y1="66%" x2="50%" y2="50%" stroke="#000" strokeWidth="1" />
        </svg>
      </div>

      <div className="container mx-auto px-8 relative z-10 max-w-7xl">
        <div className="max-w-5xl fade-in">
          {/* Crisis label */}
          <div className="mb-12 border-l-2 border-gray-900 pl-6">
            <p className="text-xs text-gray-600 uppercase tracking-[0.3em] font-medium">{t.hero.label}</p>
          </div>

          {/* Main Headline */}
          <h1 className="text-6xl md:text-8xl lg:text-[140px] font-normal mb-16 text-gray-900 leading-[0.9] tracking-tighter" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            {t.hero.headline1}<br />{t.hero.headline2}
          </h1>

          {/* Structural divider */}
          <div className="flex items-center gap-4 my-16">
            <div className="w-16 h-px bg-gray-900" />
            <div className="w-2 h-2 border border-gray-900 rotate-45" />
            <div className="flex-1 h-px bg-gray-300" />
          </div>

          {/* Operator positioning */}
          <p className="text-2xl md:text-3xl text-gray-800 mb-20 font-light leading-tight tracking-wide max-w-4xl">
            {t.hero.subheadline}
          </p>

          {/* CTA with urgency */}
          <div className="flex items-center gap-6">
            <button
              onClick={onContactClick}
              className="border-2 border-gray-900 hover:bg-gray-900 hover:text-white text-gray-900 px-12 py-5 text-sm tracking-[0.25em] uppercase transition-all font-medium"
            >
              {t.hero.cta}
            </button>
            <span className="text-sm text-gray-500 font-light">{t.hero.responseTime}</span>
          </div>
        </div>
      </div>

      {/* Bottom structural line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gray-200" />
    </section>
  );
};
